import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {IGridAppearance} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {GridRendererRegistry} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridRendererRegistry';
import {GridAppearance} from '@mintdata-wsp/wsp/ui/components/grid/appearance/general/GridAppearance';
import {ListCellAreaStyles} from '@mintdata-wsp/wsp/ui/components/grid/appearance/list/ListCellAreaStyles';
import {TextHeaderCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/columnHeader/TextHeaderCellRenderer';
import {IconCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/IconCellRenderer';
import {LetterCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/LetterCellRenderer';
import {TextCellRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/TextCellRenderer';
import {TimestampRenderer} from '@mintdata-wsp/wsp/ui/components/grid/cells/TimestampRenderer';

export class ListAppearance
{
    public static create():IGridAppearance
    {
        const rr = new GridRendererRegistry();
        rr.register(GridCellKind.Timestamp, new TimestampRenderer());
        rr.register(GridCellKind.Text, new TextCellRenderer());
        rr.register(GridCellKind.TextHeader, new TextHeaderCellRenderer());
        rr.register(GridCellKind.Icon, new IconCellRenderer());
        rr.register(GridCellKind.Letter, new LetterCellRenderer());

        return new GridAppearance(ListCellAreaStyles, rr);
    }
}
